import { render, staticRenderFns } from "./employeeDetails.vue?vue&type=template&id=0aadf8f3&scoped=true&"
import script from "./employeeDetails.vue?vue&type=script&lang=js&"
export * from "./employeeDetails.vue?vue&type=script&lang=js&"
import style0 from "./employeeDetails.vue?vue&type=style&index=0&id=0aadf8f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadf8f3",
  null
  
)

export default component.exports